<template>
  <template v-if="Array.isArray(subs) && subs.length">
    <div class="pb-2">
      <div v-for="(sub, index) in subs" :key="sub.id">
        <div @click="handleToggle(index)" class="font-semibold text-gray-700 px-3 cursor-pointer flex items-center hover:underline">
          <base-svg-icon
            class="w-6 transform transition-transform duration-500 cursor-pointer"
            :class="isOpenSub[index] ? 'rotate-90' : 'rotate-0'"
            :path="mdiChevronRight"
          />
          <div>{{ sub.name }}</div>
        </div>
        <div class="px-8">
          <video-details-category-sub-contents :isOpen="isOpenSub[index]" :videos="sub.videos" />
        </div>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue'
import { useStore } from '@/store/index'
import { VideoCategorySubAttributes } from '@/types/models/video-category-sub'
import { mdiChevronRight } from '@mdi/js'

import VideoDetailsCategorySubContents from '@/components/VideoDetailsCategorySubContents.vue'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  props: {
    subs: {
      type: Array as PropType<VideoCategorySubAttributes[]>,
      'default': () => ([]),
    }
  },
  components: {
    VideoDetailsCategorySubContents,
    BaseSvgIcon
  },
  setup(props) {
    const store = useStore()
    const isOpenSub = ref(Array(props.subs.length).fill(true))

    const handleToggle = (index: number) => {
      isOpenSub.value.splice(index, 1, !isOpenSub.value[index])
    }

    return {
      store,
      mdiChevronRight,
      isOpenSub,
      handleToggle,
    }
  }
})
</script>
